package one.healthium.cali

import kotlin.String

internal object BuildKonfig {
  public val BUILD_FLAVOUR: String = "Prod"
}
